import { render, staticRenderFns } from "./licensestatus.vue?vue&type=template&id=3c04821c&"
import script from "./licensestatus.vue?vue&type=script&lang=js&"
export * from "./licensestatus.vue?vue&type=script&lang=js&"
import style0 from "./licensestatus.vue?vue&type=style&index=0&id=3c04821c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports